import { FC } from 'react'
import { Flex } from '@/components/atoms/Grid'
import styled, { useTheme } from 'styled-components'
import { CheckIconDefault } from '../atoms/icons/CheckIconDefault'
import { getContrastColor } from '@/utils/filterHepler'

type CheckBoxProps = {
  size: number
  isChecked: boolean
  isValid?: boolean
  color?: string
  onCheckboxClick: () => void
} & Rest

const CheckBoxFilterRedesign: FC<CheckBoxProps> = ({
  size,
  isChecked,
  onCheckboxClick,
  children,
  isValid = true,
  color,
  ...rest
}) => {
  const theme = useTheme()
  const iconColor = color
    ? getContrastColor(color, theme)
    : theme.colors.background
  return (
    <StyledFlex
      cursorOnHover={true}
      alignItems="center"
      justifyContent="space-between"
      onClick={onCheckboxClick}
      {...rest}
      data-testid="checkBoxFilter"
    >
      <CheckBoxElement
        flex="0 0 auto"
        width={size}
        height={size}
        isChecked={isChecked}
        isValid={isValid}
        color={color}
      >
        {isChecked && <CheckIconDefault width="12px" color={iconColor} />}
      </CheckBoxElement>
      {children}
    </StyledFlex>
  )
}
export default CheckBoxFilterRedesign

const StyledFlex = styled(Flex)`
  padding: 4px 8px 4px 12px;
  gap: 12px;
  height: 34px;
  box-sizing: border-box;
  align-items: center;

  &:hover {
    background-color: ${(props) => props.theme.colors.navMenuGrey};
    transition: background-color 0.3s;
  }
`

const CheckBoxElement = styled<CheckBoxProps>(Flex)`
  justify-content: center;
  border-radius: 2px;
  border: 1px solid
    ${(props) =>
      props.color && props.color !== 'rgb(255, 255, 255)'
        ? props.color
        : props.theme.colors.onBackground};
  box-sizing: border-box;
  background-color: ${(props) =>
    props.color
      ? props.color
      : props.isChecked
      ? props.theme.colors.onBackground
      : props.theme.colors.background};
`
